import React from 'react';

import NCreditoLeftOver from 'components/Tvendo/Sale/Operations/NCredito/List';
import { ConstantPermissions } from 'contexts/useConstant';

export default function () {
  return (
    <NCreditoLeftOver
      title="sobrantes"
      type="NCL"
      permission={{
        show: 1,
        store: ConstantPermissions.SALE_CREDIT_NOTE_STORE,
        update: ConstantPermissions.SALE_CREDIT_NOTE_STORE,
      }}
    />
  );
}
